import React from "react";
import { Image } from "antd";

import "./index.css";

interface Props {
  src: string;
  description: string | React.ReactNode;
  width?: number;
}

export const ImageDescription = (props: Props) => {
  return (
    <div className="image-container">
      <Image src={props.src} width={props.width} preview={false} />
      <p className="image-description">{props.description}</p>
    </div>
  );
};

export default ImageDescription;
